import { render, staticRenderFns } from "./ExchangeCheckbox.vue?vue&type=template&id=3a99f9f6&scoped=true"
import script from "./ExchangeCheckbox.vue?vue&type=script&lang=js"
export * from "./ExchangeCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ExchangeCheckbox.vue?vue&type=style&index=0&id=3a99f9f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a99f9f6",
  null
  
)

export default component.exports